import { createContext } from 'react';
import { WrappedCondition } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Condition';
import { WrappedObservation } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Observation';

export interface ServiceRequestContextData {
  conditions?: WrappedCondition[];
  observations?: WrappedObservation[];
}

const initialServiceRequestContextData: ServiceRequestContextData = {
  conditions: [],
  observations: [],
};

const ServiceRequestContext = createContext<ServiceRequestContextData>(initialServiceRequestContextData);

export default ServiceRequestContext;
